import React, { useEffect, useRef, useState } from 'react'
import css from "./input.module.scss"

export const Input = ({
  type = 'text',
  placeholder,
  label,
  value,
  className,
  onChange,
  style,
  optional,
  required = false,
  search = false,
  radio=false,
  name,
  otherText,
  isDisabled=false,
  defaultValue='',
  checked=false,
  verified,
  readOnly=false,
  onClick,
  onBlur = () => {},
  clear=false,
  onClear = () => {},
  onKeyPress = () => {},
}) => {
  const [showPlaceHolder, setShowPlaceHolder] = useState(required)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (value) {
      setShowPlaceHolder(false)
    }
  }, [value])


  return (
    <>
     {!radio && <div className={`${css.inputWrapper} input-wrapper`}>
        {showPlaceHolder && <div className={css.placeholder} onClick={() => {
          document.querySelector(`.input-wrapper .${className === 'First Name' ? 'First Name' : className === 'Last Name' ? 'Last Name' : className}`)?.focus()
        }}>
          <label style={{cursor: 'text'}} >{label}</label>
          <span style={{ color: '#ed2626' }}> *</span>
        </div>
        }
      {!readOnly ?  <input type={showPassword ? 'text' : type} value={value} placeholder={placeholder} disabled={isDisabled} className={className} onChange={onChange} style={style} defaultValue={defaultValue} autoComplete='off' readOnly={readOnly} onBlur={() => !value && required ? setShowPlaceHolder(true) : setShowPlaceHolder(false)} onFocus={(e) => {
          e.target.readOnly = false
        }}
          onTouchStart={(e) => {
            e.target.readOnly = false
          }}
          onClick={onClick}
          onKeyDown={(e) => {
            type === 'password' && onKeyPress(e)
          }}
          />
          :  <input type={showPassword ? 'text' : type} value={value} placeholder={placeholder} disabled={isDisabled} className={className} onChange={onChange} style={style} defaultValue={defaultValue} autoComplete='off' readOnly={readOnly}
            onClick={onClick}
            onKeyDown={(e) => {
              type === 'password' && onKeyPress(e)
            }}
            />
        }
        {type === 'password' && <span className={css.showPassword} onClick={() => setShowPassword(!showPassword)}>{showPassword ? <i className='fal fa-eye-slash'></i> : <i className='fal fa-eye'></i>}</span>}
        {optional && <span className={css.optional}>Optional</span>}
        {search && <i className={`fal fa-search ${css.search}`}></i>}
        {otherText && <span className={css.otherText}>{otherText}</span>}
        {verified ?  <span className={css.verified}>Verified <i className="fal fa-check" /></span> : verified === false && <span className={css.notVerified}>Not Verified <i className="fal fa-times" /></span> }
        {clear ? <span className={css.clear}
        onClick={onClear}
        ><i className='fal fa-times' /></span> : null}
      </div>
}
    {radio &&  <label className={`${css.radioContainers} className`} style={style}>
        <input type="radio" name={name} value={value} onChange={onChange} checked={checked} />
        <span class={css.checkmark}></span>
        <span>{value}</span>
      </label>
}
    </>
  )
}